module.exports = __webpack_public_path__ + "img/pic10.6c769b43.png";